/* global config_coterie */

var url = config_coterie.CALLBACK_URL;

const checkPathnameStartsWith = (str = "") => {
  const matchUrls = [
    "/products/diapers",
    "/products/pants",
    "/products/wipes",
    "/auth/password-reset",
    "/faq",
    "/refer",
    "/contact",
  ];
  return matchUrls.some((matchUrl) => str.startsWith(matchUrl));
};

if (checkPathnameStartsWith(location.pathname)) {
  url += location.pathname;
}

location.href = url;
